module.exports = __webpack_public_path__ + "eb79a2e95623d19d456b03dcff54fcab.jpg";